import styled from '@emotion/styled'
import { ParagraphProps } from './Paragraph'

type ParagraphStyledProps = Pick<ParagraphProps, 'align' | 'isDesktop'>

export const ParagraphStyled = styled('p')<ParagraphStyledProps>(({ align, isDesktop }) => ({
  fontSize: isDesktop ? '1.5rem' : 'inherit',
  textAlign: align,
}))
